import { Navigate, useLocation } from "react-router-dom";

const MAINTENANCE_PATHS = new Set(["/Maintenance", "/maintenance"]);

export function isMaintenanceModeEnabled() {
  return (
    process.env.REACT_APP_MAINTENANCE_MODE === "1" ||
    process.env.REACT_APP_MAINTENANCE_MODE === "true"
  );
}

/**
 * When REACT_APP_MAINTENANCE_MODE=1, every route redirects to /Maintenance.
 */
export default function MaintenanceModeRedirect() {
  const location = useLocation();

  if (!isMaintenanceModeEnabled()) {
    return null;
  }

  const path = location.pathname.replace(/\/+$/, "") || "/";

  if (MAINTENANCE_PATHS.has(path)) {
    return null;
  }

  return <Navigate to="/Maintenance" replace />;
}
